module.exports = __webpack_public_path__ + "static/media/AboutTraceID.e7021628.gif";